import classnames from "classnames";
import { withT } from "neetocommons/react-utils";
import { Typography, Tag, Avatar } from "neetoui";

import DateFormat from "components/DateFormat";
import MoreDropdown from "components/MoreDropdown";

const Version = withT(
  ({
    t,
    id,
    date,
    user,
    onClick,
    isDraft = false,
    isPublished = false,
    showMoreDropdown = false,
    moreDropdownProps = {},
    isLast = false,
  }) => (
    <div className="flex w-full gap-2" key={id}>
      <div className="relative mt-2.5 flex flex-col items-center">
        <span
          className={classnames(
            "neeto-ui-rounded-full neeto-ui-bg-gray-300 relative z-10 h-2 w-2",
            { "neeto-ui-bg-warning-500": isDraft },
            { "neeto-ui-bg-primary-500": isPublished }
          )}
        />
        {!isLast && (
          <span
            aria-hidden="true"
            className="neeto-ui-bg-gray-300 absolute start-1/2 top-[9px] z-0 h-full w-px -translate-x-1/2 rtl:translate-x-1/2"
          />
        )}
      </div>
      <div
        {...{ onClick }}
        className={classnames("w-full", { "pb-3": !isDraft })}
      >
        <div
          className="neeto-ui-rounded hover:neeto-ui-bg-gray-100 flex flex-grow cursor-pointer justify-between gap-4 px-1.5 pb-1.5 pt-1 transition-all duration-300"
          data-testid="version-history-event"
        >
          <div className="flex flex-grow flex-col gap-2">
            <div className="flex items-center gap-2">
              <Typography style="h5" weight="medium">
                <DateFormat.DateWeekTime
                  {...{ date }}
                  typographyProps={{ style: "body3", lineHeight: "snug" }}
                />
              </Typography>
              {isDraft && (
                <Tag
                  className="float-start"
                  data-testid="version-history-draft-tag"
                  label={t("neetoMolecules.common.actions.draft")}
                  size="small"
                  style="warning"
                />
              )}
            </div>
            <div className="flex items-center gap-2">
              <Avatar size="small" user={{ name: user }} />
              <Typography style="body3">{user}</Typography>
            </div>
          </div>
          {showMoreDropdown && (
            <div className="flex-shrink-0" onClick={e => e.stopPropagation()}>
              <MoreDropdown
                dropdownButtonProps={{
                  className: "m-1",
                  size: "small",
                  disabled: moreDropdownProps.disabled,
                }}
                dropdownProps={{
                  strategy: "fixed",
                  appendTo: () => document.body,
                }}
                {...moreDropdownProps}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
);

export default Version;
